import { money } from "@/components/StatusBadge";
import { Badge } from "@/components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

// Read-only user detail drawer (deals, matches/payouts, wallet history).
export const UserDetailDialog = ({ userDetail, userDetailOpen, setUserDetailOpen }) => (
  <Dialog open={userDetailOpen} onOpenChange={setUserDetailOpen}>
    <DialogContent data-testid="user-detail-dialog" className="max-w-2xl max-h-[85vh] overflow-y-auto">
      <DialogHeader>
        <DialogTitle>{userDetail?.profile?.name || "User"} details</DialogTitle>
      </DialogHeader>
      {!userDetail ? (
        <p className="py-8 text-center text-sm text-muted-foreground">Loading…</p>
      ) : (
        <div className="space-y-5">
          <div className="rounded-lg border border-black/10 p-3 text-sm">
            <p className="font-medium">{userDetail.profile.email}</p>
            <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground">
              <span>Role: <b className="text-foreground">{userDetail.profile.role || "user"}</b></span>
              <span>Wallet: <b className="text-foreground">{money(userDetail.profile.wallet_balance)}</b></span>
              <span>Promo: <b className="text-foreground">{money(userDetail.profile.promo_balance || 0)}</b></span>
              <span>Phone verified: <b className="text-foreground">{userDetail.profile.phone_verified ? "Yes" : "No"}</b></span>
              <span>Joined: <b className="text-foreground">{(userDetail.profile.created_at || "").slice(0, 10)}</b></span>
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold text-foreground/70">Deals ({userDetail.counts.deals})</p>
            <div className="mt-2 rounded-lg border border-black/10 divide-y divide-black/5 max-h-40 overflow-y-auto">
              {userDetail.deals.length === 0 ? <p className="p-3 text-sm text-muted-foreground">No deals.</p> :
                userDetail.deals.map((d) => (
                  <div key={d.deal_id} className="flex items-center justify-between p-2.5 text-sm">
                    <span className="truncate">{d.title}</span>
                    <Badge variant="outline" className="ml-2 font-normal shrink-0">{d.status}</Badge>
                  </div>
                ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold text-foreground/70">Deals / payouts ({userDetail.counts.matches})</p>
            <div className="mt-2 rounded-lg border border-black/10 divide-y divide-black/5 max-h-40 overflow-y-auto">
              {userDetail.matches.length === 0 ? <p className="p-3 text-sm text-muted-foreground">No matches.</p> :
                userDetail.matches.map((m) => (
                  <div key={m.match_id} className="flex items-center justify-between gap-2 p-2.5 text-sm">
                    <span className="truncate">{m.deal_title}</span>
                    <span className="flex items-center gap-2 shrink-0">
                      <Badge variant="outline" className="font-normal">{m.role}</Badge>
                      <span className="text-muted-foreground text-xs">{m.status}</span>
                      <span className="font-heading" style={{ fontWeight: 700 }}>{money(m.amount)}</span>
                    </span>
                  </div>
                ))}
            </div>
          </div>

          <div>
            <p className="text-xs font-semibold text-foreground/70">Wallet history ({userDetail.counts.transactions})</p>
            <div className="mt-2 rounded-lg border border-black/10 divide-y divide-black/5 max-h-48 overflow-y-auto">
              {userDetail.transactions.length === 0 ? <p className="p-3 text-sm text-muted-foreground">No transactions.</p> :
                userDetail.transactions.map((t) => (
                  <div key={t.txn_id} className="flex items-center justify-between gap-2 p-2.5 text-sm">
                    <div className="min-w-0">
                      <p className="truncate">{t.description || t.type}</p>
                      <p className="text-[11px] text-muted-foreground">{(t.created_at || "").slice(0, 10)} · {t.bucket || "cash"}</p>
                    </div>
                    <span className={`font-heading shrink-0 ${(t.amount || 0) < 0 ? "text-red-600" : "text-green-700"}`} style={{ fontWeight: 700 }}>
                      {(t.amount || 0) < 0 ? "-" : "+"}{money(Math.abs(t.amount || 0))}
                    </span>
                  </div>
                ))}
            </div>
          </div>
        </div>
      )}
    </DialogContent>
  </Dialog>
);

export default UserDetailDialog;
